import IframeSection from 'components/Rhs/IframeSection';
import ListingWidget from 'components_v2/common/ListingWidget';
// import TOIPlusStories from 'components/TOIPlusStories/TOIPlusStoriesLoader';
// import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen';
// import CounterWidigtsIframe from 'components/CounterWidigtsIframe';
import Banner from 'components/Rhs/Banner';
// import ElectionBanner from 'components/Rhs/ElectionBanner';
//import WithRhsScorecard from 'components_v2/common/RhsScorecard';
import AdCaller from 'helpers/ads/adCaller';
// import RHSWidgetWithExitPoll from 'components_v2/common/ExitPollRHSWrapper';
// import CoronaWidget from 'components_v2/common/CoronaWidgetMView';
import TimesClubWebRHS from 'components/TimesClubWebRHS/TimesClubWebRHS';
import LiveblogWidgetRhs from 'components_v2/common/LiveblogWidgetRhs/LiveblogWidgetRhs';
import CardListRhs from 'components_v2/common/CardListRhs';
// import TimesAssist from 'components_v2/common/TimesAssist';
import RHSRelatedVideos from 'components_v2/desktop/RHSRelatedVideos/RHSRelatedVideos';
import TwoColumnsCardWidget from 'components_v2/desktop/TwoColumnsCardWidget/TwoColumnsCardWidget';
import ETNewsLetter from 'components_v2/desktop/ETNewsLetter/ETNewsLetter';
import TOIPlusWidget from 'components_v3/desktop/TOIPlusWidget/TOIPlusWidget';
import AffiliatesContent from '../../../../components/AffiliatesContentV2/AffiliatesContentV2';
// import MidArticleSearchRHS from '../../../../components_v2/desktop/MidArticleSearchRHS/MidArticleSearchRHS';
import TabListingWidget from '../../../../components_v2/desktop/TabListingWidget/TabListingWidget';
import CalculatorList from '../../../calculator/components/mobile/CalculatorList/CalculatorList';
import LoadableComponentLoader from '../../../../components_v2/common/LoadableComponentLoader/LoadableComponentLoader';

export default {
  // times_assist: TimesAssist,
  ad: AdCaller,
  video_widget: RHSRelatedVideos,
  scorecardwidget: LoadableComponentLoader,
  column_2_cardlist: TwoColumnsCardWidget,
  etimes_newsletter: ETNewsLetter,
  iframe: IframeSection,
  list: ListingWidget,
  cardlist: CardListRhs,
  // primeinlinewidget: PrimeScreen,
  timesclub: TimesClubWebRHS,
  // toipluswidget: TOIPlusStories,
  banner: Banner,
  //searchwidget: MidArticleSearchRHS,
  tab_list: TabListingWidget,
  calculator: CalculatorList,
  // el_banner: ElectionBanner,
  // electionexitpoll: RHSWidgetWithExitPoll,
  // CovidWidget: CoronaWidget,
  // counterwidigtsiframe: CounterWidigtsIframe,
  //scorecard: WithRhsScorecard,
  lbgwidget: LiveblogWidgetRhs,
  affiliatesContent: AffiliatesContent,
  TOIPlusWidget,
};

// Section wise
export const firstNonAdWidget = section => {
  let tn = '';
  switch (section) {
    case 'business': {
      tn = 'toipluswidget';
      break;
    }
    case 'city': {
      tn = 'list';
      break;
    }
    case 'india': {
      tn = 'list';
      break;
    }
    case 'sports': {
      tn = 'toipluswidget';
      break;
    }
    case 'world': {
      tn = 'toipluswidget';
      break;
    }
    default:
      tn = 'toipluswidget';
  }
  return tn;
};
